import { render, staticRenderFns } from "./FooterLayout.vue?vue&type=template&id=579bbffa&"
import script from "./FooterLayout.vue?vue&type=script&lang=js&"
export * from "./FooterLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports